/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import IndeterminateCheckbox from "../components/IndeterminateChechbox";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import { toast } from "react-toastify";

export default function DealerList({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const [dealers, setDealers] = useState([]);

  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang.dealer_name || "Dealer Name",
      accessorKey: "customer_name",
    },
    {
      header: lang.Email || "Email",
      accessorKey: "email",
    },
    {
      header: lang.Valid_Identity_Number || "Valid Identity Number",
      accessorKey: "valid_id_number",
    },
    {
      header: lang.branch_name || "Office Name",
      accessorKey: "branch_name",
    },
    {
      header: lang.light_mode || "Light Mode",
      cell: (row) => (
        <ModeChange
          id={row.row.original.id}
          mode={row.row.original.light_mode}
        />
      ),
    },
    {
      header: lang["Use Shift"] || "Use Shift",
      accessorKey: "use_shift",
      cell: (row) => <UseShift id={row.row.original.id} use_shift={row.getValue()} />
    },
    {
      header: lang.dealer_type || "Dealer Type",
      accessorKey: "dealer_type",
    },
    {
      header: lang.Status || "Status",
      accessorKey: "status",
      cell: (row) =>
        row.getValue() == 1 ? (
          <span className="badge bg-success">{lang.active || "Active"}</span>
        ) : (
          <span className="badge bg-danger">{lang.inactive || "Inactive"}</span>
        ),
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <Link
                className="dropdown-item mt-0"
                to={"/dashboard/dealer-list/" + row.row.original.id}
              >
                {lang.change_password || "Change Password"}
              </Link>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => {
                  if (row.row.original.status == 1) {
                    deactivateDealer(row.row.original.id);
                  } else {
                    activateDealer(row.row.original.id);
                  }
                }}
              >
                {row.row.original.status === 1 ? lang["Deactivate"] || "Deactivate" : lang["Activate"] || "Activate"}
              </button>
            </li>
            {parseInt(row.row.original.is_verified) === 0 && (
              <li>
                <button
                  onClick={() => navigate(`verify-otp/${row.row.original.id}`)}
                  className="dropdown-item mt-0"
                >
                  Verify OTP
                </button>
              </li>
            )}
          </ul>
        </div>
      ),
    },
  ];

  const navigate = useNavigate();

  const deactivateDealer = (id) => {
    axios
      .put(`${apiKey}/deactivate-dealer/${id}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        axios
          .get(apiKey + "/get-dealers", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setDealers(res.data.result);
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const activateDealer = (id) => {
    axios
      .put(`${apiKey}/activate-dealer/${id}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        axios
          .get(apiKey + "/get-dealers", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setDealers(res.data.result);
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    try {
      axios
        .get(apiKey + "/get-dealers", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setDealers(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [token]);
  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Dealer_Management || "Dealer Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.Dealer_Management || "Dealer Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.dealer_list || "Dealer List"}
              </li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-9"></div>
                    <div className="col-3">
                      <Link to="add-new-dealer">
                        <button type="button" className="btn btn-primary ms-4">
                          <img
                            src="img/fi_plus.png"
                            alt=""
                            className="img-fluid me-2"
                          ></img>
                          {lang.add_new_dealer || "Add New Dealer"}
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="row pt-3">
                    <div className="rr col-9">
                      {lang.dealer_list || "Dealer List"}
                    </div>
                  </div>

                  <div classNames="d-flex mt-3 mb-3">
                    <Table lang={lang} data={dealers} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

function ModeChange({ id, mode }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const [isChecked, setIsChecked] = useState(mode);
  const handleChange = () => {
    const updatedMode = mode === "yes" ? "no" : "yes";
    axios
      .put(
        `${apiKey}/dealer-mode-update/${id}`,
        {
          mode: updatedMode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.Message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setIsChecked(updatedMode);
      })
      .catch((err) => {
        toast.error(err.response.data.Error, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  return (
    <span className="w-100 d-block">
      <input
        type="checkbox"
        className="mx-auto"
        checked={isChecked === "yes"}
        onChange={handleChange}
      />
    </span>
  );
}

function UseShift({
  id,
  use_shift
}) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const [isChecked, setIsChecked] = useState(use_shift);
  const handleChange = () => {
    const updatedUseShift = use_shift === 1 ? 0 : 1;
    axios
      .put(
        `${apiKey}/dealer-use-shift-update/${id}`,
        {
          use_shift: updatedUseShift,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.Message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setIsChecked(updatedUseShift);
      })
      .catch((err) => {
        toast.error(err.response.data.Error, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  return (
    <span className="w-100 d-block">
      <input
        type="checkbox"
        className="mx-auto"
        checked={isChecked === 1}
        onChange={handleChange}
      />
    </span>
  );
}
